import Const from './js/const'
import * as Data from './js/data'
import * as Util from './js/utils'
import { t } from './i18n/index'

import Api from './api/index'
import Filter from './filters/index'

const Core = {
    Const,
    Util,
    Api,
    Data,
    Filter,
    t,
    auth: Util.auth,
}
export default Core
